<small class="debug">{{me}}</small>
@if (googleMapApiLoaded) {
  <google-map height="700px"
    width="100%"
    [center]="center"
    [zoom]="zoom"
    [mapId]="mapId"
    (mapClick)="addMarker($event)"
    (mapMousemove)="move($event)"
    (mapRightclick)="removeLastMarker()"
    >
    @for (markerPosition of markerPositions; track markerPosition) {
      <map-advanced-marker #marker
        [position]="markerPosition"
        [options]="{'title': markerPosition.label}"
        (mapClick)="openInfoWindow(marker)"
        >
      </map-advanced-marker>
    }
    <!-- <map-marker #marker
    *ngFor="let markerPosition of markerPositions"
    [position]="markerPosition"
    [options]="{'opacity': markerPosition.color === 'down' ? 0.3 : 1, 'title': markerPosition.label}"
    (mapClick)="openInfoWindow(marker)">
  </map-marker> -->
  <map-info-window></map-info-window>
  <!-- [options]="getOptions($markerPosition)"-->
</google-map>
<div>Latitude: {{display?.lat}}</div>
<div>Longitude: {{display?.lng}}</div>
}
